const KanbanIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5135 15.1668H2.82016C1.48016 15.1668 0.833496 14.5468 0.833496 13.2668V2.7335C0.833496 1.4535 1.48683 0.833496 2.82016 0.833496H5.5135C6.8535 0.833496 7.50016 1.4535 7.50016 2.7335V13.2668C7.50016 14.5468 6.84683 15.1668 5.5135 15.1668ZM2.82016 1.8335C1.9735 1.8335 1.8335 2.06016 1.8335 2.7335V13.2668C1.8335 13.9402 1.9735 14.1668 2.82016 14.1668H5.5135C6.36016 14.1668 6.50016 13.9402 6.50016 13.2668V2.7335C6.50016 2.06016 6.36016 1.8335 5.5135 1.8335H2.82016Z"
        fill="CurrentColor"
      />
      <path
        d="M13.18 10.5002H10.4867C9.14667 10.5002 8.5 9.88016 8.5 8.60016V2.7335C8.5 1.4535 9.15333 0.833496 10.4867 0.833496H13.18C14.52 0.833496 15.1667 1.4535 15.1667 2.7335V8.60016C15.1667 9.88016 14.5133 10.5002 13.18 10.5002ZM10.4867 1.8335C9.64 1.8335 9.5 2.06016 9.5 2.7335V8.60016C9.5 9.2735 9.64 9.50016 10.4867 9.50016H13.18C14.0267 9.50016 14.1667 9.2735 14.1667 8.60016V2.7335C14.1667 2.06016 14.0267 1.8335 13.18 1.8335H10.4867Z"
        fill="CurrentColor"
      />
    </svg>
  );
};

export { KanbanIcon };
export default KanbanIcon;
